import { TDeferredTypeId as TDeferredTypeId$1, _await as _await$1, done as done$1, fail as fail$1, make as make$1, poll as poll$1, succeed as succeed$1 } from '../../internal/stm/tDeferred.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const TDeferredTypeId = TDeferredTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

const _await = _await$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const done = done$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const fail = fail$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * @since 2.0.0
 * @category getters
 */
const poll = poll$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const succeed = succeed$1;

export { TDeferredTypeId, _await as await, done, fail, make, poll, succeed };
